import axios from "axios";

export const getUserActivate = async (id:number) => {
    return await axios({
		url: `/User/Activate?id=${id}`,
		method: "GET",
	});
}